module.exports = __webpack_public_path__ + "img/mkz.b174f4bb.png";